import { SettingsParamType, createSettingsParams } from '@wix/tpa-settings';
import {
  settingsParams as menusSettingsParams,
  type ISettingsParams as IMenusSettingsParams,
  type SettingsParamsType,
} from 'root/components/Menus/settingsParams';
import { ALL_FEATURED_TYPES } from 'root/utils/featuredType';
import { WidgetType, ItemsToShow } from './Settings/Tabs/MenusTab/consts';
import { menuAddOnDefaultText } from './defaultText';

export type IMenuAddOnSettingsParams = IMenusSettingsParams & {
  widgetType: SettingsParamType.String;
  selectedMenuId: SettingsParamType.String;
  itemsToShow: SettingsParamType.String;
  selectedSectionId: SettingsParamType.String;
  selectedRibbon: SettingsParamType.String;
  selectedItemIds: SettingsParamType.String;
  showViewFullMenuButton: SettingsParamType.Boolean;
  showAddToCartButton: SettingsParamType.Boolean;
  menuTitleText: SettingsParamType.String;
  menuSubtitleText: SettingsParamType.String;
  viewFullMenuButtonText: SettingsParamType.String;
  addToCartButtonText: SettingsParamType.String;
};

const globalKey = (key: string) => key;

const menuAddOnOnlyParams = createSettingsParams<
  Pick<
    IMenuAddOnSettingsParams,
    | 'widgetType'
    | 'selectedMenuId'
    | 'itemsToShow'
    | 'selectedSectionId'
    | 'selectedRibbon'
    | 'selectedItemIds'
    | 'showViewFullMenuButton'
    | 'showAddToCartButton'
    | 'menuTitleText'
    | 'menuSubtitleText'
    | 'viewFullMenuButtonText'
    | 'addToCartButtonText'
    | 'showImagePlaceholder'
  >
>({
  widgetType: {
    type: SettingsParamType.String,
    getDefaultValue: () => WidgetType.Menu,
    dangerousKeyTransformationOverride: globalKey,
  },
  selectedMenuId: {
    type: SettingsParamType.String,
    getDefaultValue: () => '',
    dangerousKeyTransformationOverride: globalKey,
  },
  itemsToShow: {
    type: SettingsParamType.String,
    getDefaultValue: () => ItemsToShow.All,
    dangerousKeyTransformationOverride: globalKey,
  },
  selectedSectionId: {
    type: SettingsParamType.String,
    getDefaultValue: () => '',
    dangerousKeyTransformationOverride: globalKey,
  },
  selectedRibbon: {
    type: SettingsParamType.String,
    getDefaultValue: () => ALL_FEATURED_TYPES,
    dangerousKeyTransformationOverride: globalKey,
  },
  selectedItemIds: {
    type: SettingsParamType.String,
    getDefaultValue: () => '',
    dangerousKeyTransformationOverride: globalKey,
  },
  showViewFullMenuButton: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
    dangerousKeyTransformationOverride: globalKey,
  },
  showAddToCartButton: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => false,
    dangerousKeyTransformationOverride: globalKey,
  },
  menuTitleText: {
    type: SettingsParamType.String,
    getDefaultValue: () => menuAddOnDefaultText.menuTitle.fallback,
    dangerousKeyTransformationOverride: globalKey,
  },
  menuSubtitleText: {
    type: SettingsParamType.String,
    getDefaultValue: () => menuAddOnDefaultText.menuSubtitle.fallback,
    dangerousKeyTransformationOverride: globalKey,
  },
  viewFullMenuButtonText: {
    type: SettingsParamType.String,
    getDefaultValue: () => menuAddOnDefaultText.viewFullMenuButton.fallback,
    dangerousKeyTransformationOverride: globalKey,
  },
  addToCartButtonText: {
    type: SettingsParamType.String,
    getDefaultValue: () => menuAddOnDefaultText.addToCartButton.fallback,
    dangerousKeyTransformationOverride: globalKey,
  },
  showImagePlaceholder: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
    dangerousKeyTransformationOverride: globalKey,
  },
});

export const settingsParams: SettingsParamsType<IMenuAddOnSettingsParams> = {
  ...menusSettingsParams,
  ...menuAddOnOnlyParams,
};

export default settingsParams;

export type {
  SettingsParamsType,
  SettingParamValue,
  ExtractSettingParamValue,
  SettingParamsByType,
  SettingParamKeysByType,
} from 'root/components/Menus/settingsParams';

export type ISettingsParams = IMenuAddOnSettingsParams;
